import {dataTemplate} from './dataTemplate';

const Values = dataTemplate('values');

export default Values;
